import { render } from "./EmailSharing.vue?vue&type=template&id=d3882768"
import script from "./EmailSharing.vue?vue&type=script&lang=ts"
export * from "./EmailSharing.vue?vue&type=script&lang=ts"
script.render = render

export default script